import { useContext } from 'react';

import { XYChartColorPaletteContext } from '../context/XYChartColorPalette.context.js';

export const useColorPalette = () => useContext(XYChartColorPaletteContext);
